import React, { useState, useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { useNavigate } from 'react-router-dom';
import { loadingDispatch } from './../../app/utils';
import {
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Button,
  Box,
  CircularProgress,
  Grid,
  Paper,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TagsList from '../Common/TagsList';
import { fetchUsers } from '../UserManagement/UserSlice';
import { searchObject } from '../../app/utils';
import WorkLogTable from '../InvestmentLending_BorrowerPages/Components/ClockIn_ClockOut';

function UserList() {
  const { loading } = useAppSelector((state) => state.appData);
  const { users } = useAppSelector((state) => state.usermanagement);
  const [keyedUsers, setKeyedUsers] = useState<any[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [searchUserString, setSearchUserString] = useState('');

  const dispatch = useAppDispatch();
  let navigate = useNavigate();

  const [showDetail, setShowDetail] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [user, setUser] = useState(null);

  const selectUser = (id: string) => {
    navigate('/usermanagement/' + id);
  };

  const isSelected = (id: string) => selectedUsers.indexOf(id) !== -1;

  useEffect(() => {
    let i = 0;
    let tmpDataSet: object[] = [];
    users.forEach((d:any) => {
      tmpDataSet.push({ key: i++, ...d });
    });
    setKeyedUsers(tmpDataSet);
  }, [users]);

  const filteredUsers = keyedUsers.filter(
    (user) => {
      return searchObject(searchUserString, user, ['email', 'name', 'role']);
    },
    [searchUserString]
  );

  console.log(filteredUsers);

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        overflow: 'auto'
      }}
    >
      {loading ? (
        <Box
          sx={{
            // backgroundColor: 'rgba(0,0,0,0.8)',
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <CircularProgress
            size={100}
            thickness={4}
            sx={{ color: 'var(--color-ocean-highlight)' }}
          />
        </Box>
      ) : users.length ? (
        <Box>
          <WorkLogTable/>

          <TableContainer>
            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ color: 'white', background: 'var(--color-dark-gray)' }}
                    align="left"
                  >
                    Name
                  </TableCell>
                  <TableCell
                    sx={{ color: 'white', background: 'var(--color-dark-gray)' }}
                    align="left"
                  >
                    Email
                  </TableCell>
                  <TableCell
                    sx={{ color: 'white', background: 'var(--color-dark-gray)' }}
                    align="left"
                  >
                    Role
                  </TableCell>
                  {/* <TableCell
                    sx={{ color: 'white', background: 'var(--color-dark-gray)' }}
                    align="center"
                  >
                    <MoreHorizIcon fontSize="medium" />
                  </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody sx={{ color: 'white' }}>
                {filteredUsers.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                      color: 'white',
                      m: '2rem'
                    }}
                  >
                    <TableCell sx={{ color: 'white' }} align="left">
                      {row.userDetails.name}
                    </TableCell>
                    <TableCell sx={{ color: 'white' }} align="left">
                      {row.email}
                    </TableCell>
                    <TableCell sx={{ color: 'white', textTransform: 'capitalize' }} align="left">
                      {row.userDetails.role}
                    </TableCell>
                    {/* <TableCell align="center">
                      <IconButton sx={{ color: 'white' }} id="button">
                        <MoreHorizIcon fontSize="medium" />
                      </IconButton>
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <>No Projects</>
      )}
    </Box>
  );
}

export default UserList;
